import env from 'env';
import Auth from 'services/auth';
import { login, logout } from 'actions';

export default async function authenticate(dispatch) {
  try {
    const d: {id?: number, x?: string} = {};
    if(env.env === 'dev') {
      d.id = parseInt(localStorage.getItem('userID')) || 901;
    } else {
      d.x= window.location.search.replace('?x=', '');
    }
    const { data } = await Auth.login(d);
    if (!data) throw { message: data }
    dispatch(login({ ...data, isAdmin: data.privileges.includes('/admin/assignUserToRole') }));
  } catch ({ message }) {
    dispatch(logout());
  }
}
